(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('rcsChannelService',
            ['$uibModal',
                function ($uibModal) {

                    var fac = {
                        getRcsConfig: getRcsConfig,
                        getTesters: getTesters
                    };
                    return fac;

                    function getRcsConfig(params, secondParams) {
                        $uibModal.open({
                            templateUrl: 'components/channels/rcs/templates/rcsConfig.html',
                            size: 'md',
                            resolve: {
                                rcsConfig: ['$q', '$stateParams', 'rcsServices', function ($q, $stateParams, rcsServices) {
                                    var agent = secondParams ? secondParams : params;
                                    return rcsServices.getRcsAgent($stateParams.pickedApiSpaceId, agent.agentId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (error) {
                                            console.error(JSON.stringify(error));
                                            return $q.reject(error);
                                        });
                                }],
                            },
                            controller: 'rcsController'
                        });
                    }

                    function getTesters(params, secondParams) {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/channels/rcs/templates/rcsTestersConfig.html',
                            size: 'lg',
                            resolve: {
                                testersProfiles: ['$q', '$stateParams', 'rcsServices', function ($q, $stateParams, rcsServices) {
                                    return rcsServices.getAgentsTestersProfiles($stateParams.pickedApiSpaceId, secondParams.testers)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                                rcsConfig: function () {
                                    return secondParams ? secondParams : params;
                                }
                            },
                            controller: 'rcsTestersController'
                        });

                        modalInstance.result.then(function (result) {
                            secondParams.testers = result;
                        });
                    }

                }]);

})(window.angular);